import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragDrop = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-drag-drop",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 13l9 3l-4 2l-2 4l-3 -9" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 3l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 3l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 3l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 3l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 7l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 11l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 15l0 .01" })
	]
});
const ForwardRef = forwardRef(SvgDragDrop);
export default ForwardRef;
